import React, { useEffect, useState, useMemo } from 'react';
import apis from '../../../../apis';
import { message, Empty } from '@drip/drip-design';
import './index.less';
import utils from '@/common/utils';
import { Chart, Axis, Tooltip, Interval, Interaction, Coordinate } from 'bizcharts';
import ScrollX from '@/components/scroll-x';

export default function (props) {
  const [data, setData] = useState({});
  useEffect(() => {
    if (!props.conditions.planCode || props.conditions.realTimeData) return;
    apis.queryBaseInfoList({ ...props.conditions }).then((res) => {
      const { ret, data, msg } = res;
      if (ret === '0') {
        setData(data);
      } else {
        message.error(msg);
        setData({});
      }
    });
  }, [props.conditions]);
  const scale = {
    rate: {
      formatter: (val) => {
        return utils.formatPriceWithPercent(val * 100) + '%';
      },
      alias: '比例',
    },
  };

  const getChart = (data) => {
    return (
      <Chart data={data} height={260} autoFit padding={[15, 0, 25, 0]} scale={scale}>
        <Coordinate type="theta" radius={0.8} innerRadius={0.75} />
        <Axis visible={false} />
        <Tooltip />
        <Interval
          adjust="stack"
          position="rate"
          color="name"
          label={[
            'name',
            (item) => {
              return {
                offset: 20,
                content: (data) => {
                  return `${data.name} ${utils.formatPriceWithPercent(data.rate * 100)}%`;
                },
              };
            },
          ]}
        />
        <Interaction type="element-single-selected" />
      </Chart>
    );
  };

  const getColumnChart = (data) => {
    return (
      <Chart height={420} autoFit data={data} scale={scale}>
        <Interval position="name*rate" />
        <Axis
          name="name"
          label={{
            autoEllipsis: true,
            autoHide: false,
            autoRotate: false,
          }}
        />
        <Tooltip shared />
      </Chart>
    );
  };

  const getBarChart = (data) => {
    return (
      <Chart data={data} height={400} autoFit theme={{ maxColumnWidth: 20 }} scale={scale}>
        <Coordinate transpose scale={[1, -1]} />
        <Axis
          name="name"
          label={{
            autoEllipsis: true,
            autoHide: false,
            autoRotate: false,
          }}
        />
        <Axis
          name="rate"
          grid={{
            line: {
              type: 'line',
              style: {
                stroke: '#ccc',
                lineDash: [3, 3],
              },
            },
          }}
          label={null}
        />
        <Tooltip />
        <Interval position="name*rate" />
      </Chart>
    );
  };

  const getBar2Chart = (data) => {
    return (
      <ScrollX limit={20} width={550} height={420} length={data.length} scale={scale}>
        <Chart height={400} autoFit data={data} padding="auto" scale={scale}>
          <Axis
            name="name"
            label={{
              autoHide: false,
            }}
          />

          <Tooltip />
          <Interval position="name*rate" />
        </Chart>
      </ScrollX>
    );
  };
  console.log('数据刷新了', data);

  const Basedata = useMemo(() => {
    return (
      <>
        <div className="user-analysis-user-base-card">
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ flex: '1' }}>
              {data.cppBaseSex && (
                <>
                  <div className="user-analysis-user-base-title">用户性别分布：以【{data.cppBaseSex[0].name}】居多</div>
                  {getChart(data.cppBaseSex)}
                </>
              )}
            </div>
            <div style={{ flex: '1' }}>
              {data.cppBaseAge && (
                <>
                  <div className="user-analysis-user-base-title">
                    用户年龄段分布：以【{data.cppBaseAge[0].name}】居多
                  </div>
                  {getChart(data.cppBaseAge)}
                </>
              )}
            </div>
            <div style={{ flex: '1' }}>
              {data.cppBaseMarriage && (
                <>
                  <div className="user-analysis-user-base-title">
                    婚姻状态分布：【{data.cppBaseMarriage[0].name}】人士为主
                  </div>
                  {getChart(data.cppBaseMarriage)}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="user-analysis-user-base-card">
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ flex: '1', marginRight: '10px' }}>
              {data.cppBaseProfession1 && (
                <>
                  <div className="user-analysis-user-base-title">
                    职业分布情况：以【{data.cppBaseProfession1[0].name}】居多
                  </div>
                  {getColumnChart(data.cppBaseProfession1)}
                </>
              )}
            </div>
            <div style={{ flex: '1' }}>
              {data.cppBaseEducation && (
                <>
                  <div className="user-analysis-user-base-title">
                    学历分布情况：用户学历多数在【{data.cppBaseEducation[0].name}】
                  </div>
                  {getColumnChart(data.cppBaseEducation)}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="user-analysis-user-base-card">
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ width: '50%' }}>
              {data.cppAddrProvince && (
                <>
                  <div className="user-analysis-user-base-title">
                    省份分布：用户主要集中在【{data.cppAddrProvince[0].name}
                    {data.cppAddrProvince[1] ? '、' + data.cppAddrProvince[1].name : ''}
                    {data.cppAddrProvince[2] ? '、' + data.cppAddrProvince[2].name : ''}】等省份
                  </div>
                  {getBar2Chart(data.cppAddrProvince)}
                </>
              )}
            </div>
            <div style={{ width: '50%', marginRight: '10px' }}>
              {data.cityLevel && (
                <>
                  <div className="user-analysis-user-base-title">
                    城市等级分布：用户主要集中在【{data.cityLevel[0].name}】等城市
                  </div>
                  {getBarChart(data.cityLevel)}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="user-analysis-user-base-card">
          <div style={{ width: '100%' }}>
            {data.cppAddrCity && (
              <>
                <div className="user-analysis-user-base-title">
                  城市分布：用户主要集中在【{data.cppAddrCity[0].name}
                  {data.cppAddrCity[1] ? '、' + data.cppAddrCity[1].name : ''}
                  {data.cppAddrCity[2] ? '、' + data.cppAddrCity[2].name : ''}】等城市
                </div>
                {getBar2Chart(data.cppAddrCity)}
              </>
            )}
          </div>
        </div>
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div>
      {Object.keys(data).length !== 0 ? (
        <>{Basedata}</>
      ) : (
        <div className="user-analysis-user-shopping-card">
          <Empty description="暂无数据" />
        </div>
      )}
    </div>
  );
}
